module.exports = __webpack_public_path__ + "static/media/nibrt.9ba5c444.png";